import { TAX_PAYMENT_PERIOD_TYPES_ENUM } from 'src/common/enums';

export enum LicenseType {
  Permit = 'permit',
  Str = 'str',
  TaxCertificate = 'taxCertificate',
}

export const getLicenseTypeLabels = (
  typeVerbiage: string
): Record<LicenseType, string> => ({
  [LicenseType.Permit]: typeVerbiage,
  [LicenseType.Str]: typeVerbiage,
  [LicenseType.TaxCertificate]: 'Tax Certificate',
});

export interface Owner {
  firstName: string;
  lastName: string;
  mailingAddress: string;
  phone: string;
  email: string;
  companyName?: string;
  name?: string;
  misc?: Record<string, unknown>;
}

export interface PersonWithFormFields extends Owner {
  sameAsPropertyAddress?: boolean;
}

export interface LicensePeople {
  homeOwnersAssociation?: PersonWithFormFields;
  localContact: PersonWithFormFields;
  owner: Owner | Owner[];
  propertyManager: PersonWithFormFields;
  registrant: PersonWithFormFields;
  tenant?: PersonWithFormFields;
}

export interface License extends BaseLicense {
  /** @deprecated Use `applicationNumber` from `BaseLicense` instead. */
  application_number: string;
  canRenew?: boolean;
  /** @deprecated Use `expirationDate` from `BaseLicense` instead. */
  expiration_date?: string;
  owner?: Owner | Owner[];
  property_address?: string;
  totPaymentPeriod?: TAX_PAYMENT_PERIOD_TYPES_ENUM;
  /** @deprecated Use `unitNumber`*/
  unit_number?: string;
  unitNumber?: string;
  license_type?: LicenseType;
}

export interface LooseLicense extends BaseLicense {
  allOwnersArray?: string[];
  ownersNames: string;
  ownersNameToolTip: string;
}
export interface ReportingHistoryCertificateInfo {
  applicationDate?: string;
  applicationNumber?: string;
  expirationDate?: string;
  licenseNumber?: string;
}

export interface ReportingHistoryPropertyInfo {
  propertyAddress?: string;
  unitNumber?: string;
}

export interface ReportingHistoryRenewal {
  status: string;
}

export interface ReportingHistoryPayment {
  paymentId: string;
}

export interface ReportingHistoryPaymentPeriod {
  endDate: string;
  hideTaxFlow?: boolean;
  label: string;
  payments: ReportingHistoryPayment[];
  startDate: string;
}

export interface ReportingHistory {
  certificateInfo?: ReportingHistoryCertificateInfo;
  paymentPeriods: ReportingHistoryPaymentPeriod[];
  propertyInfo?: ReportingHistoryPropertyInfo;
  renewals?: ReportingHistoryRenewal[];
  status?: string;
  totPayable?: boolean;
}

export interface BaseLicense {
  address: string;
  applicationNumber: string;
  canRenew?: boolean;
  expirationDate?: string | null;
  isActionable?: boolean;
  isInactive?: boolean;
  license_else_application_number?: string;
  license?: string;
  licenseNumber?: string | null;
  permitNumber?: string | null;
  ownerName?: string;
  status: string;
}
